import React from 'react';
import useBodyOverflowHidden from './useBodyOverflowHidden';
import { useEffect ,useRef} from 'react';
import "./BottomDrawer.scss";
const BottomDrawer = ({ drawerContent, closeDrawer }) => {
  useBodyOverflowHidden();
  const bottomDrawerRef = useRef();
  const outsideClickEvent = (e) => {
    if (e.target.className === 'bottomDrawerContainer') {
      handleDrawerClose();
    }
  };

  useEffect(() => {
    document.addEventListener('click', outsideClickEvent);
    bottomDrawerRef.current.style.bottom = `-${bottomDrawerRef.current.offsetHeight}px`;
    bottomDrawerRef.current.style.bottom = '0';
    return () => {
      document.removeEventListener('click', outsideClickEvent);
    };
  }, [outsideClickEvent]);

  const handleDrawerClose = () => {
    bottomDrawerRef.current.style.bottom = `-${bottomDrawerRef.current.offsetHeight}px`;
    setTimeout(() => {
      closeDrawer();
    }, 500);
  };

  return (
    <div className="bottomDrawerContainer">
      <div className="bottomDrawer" ref={bottomDrawerRef}>
        <div className="bottomDrawer__header">
          <span>Your Reward Details</span>
          <img src="https://cdn-wl-assets.classplus.co/production/single/learn/b9fe02b3-26e3-468f-a8ea-a8c44c9ae65b.png" alt="crossIcon" onClick={handleDrawerClose} />
        </div>
        <div className="bottomDrawer__content">
          {drawerContent?.coupon?.howToRedeem && (
            <div className="bottomDrawer__content__block">
              <div className="bottomDrawer__content__block__header">
                <img src="https://cdn-wl-assets.classplus.co/production/single/learn/b9fe02b3-26e3-468f-a8ea-a8c44c9ae65b.png" style={{mixBlendMode:"difference",width:"10%"}} alt="icon" />
                <p>How to Redeem</p>
              </div>
              <ul>
                {drawerContent?.coupon?.howToRedeem?.linkText && (
                    drawerContent?.coupon?.websiteLink ?
                  <li
                    onClick={()=>{
                    window?.mobile?.onDeeplinkExecutedV2(
                            JSON.stringify(
                              {
                                screen: "UTIL_WEBVIEW",
                                paramOne:drawerContent?.coupon?.websiteLink,
                                paramTracking:drawerContent?.coupon?.code,
                              },"SOURCE_HOME"
                            )
                          )}}
                        dangerouslySetInnerHTML={{
                          __html: decodeURI(drawerContent?.coupon?.howToRedeem?.linkText),
                        }}>
                  </li>
                        :
                  <li>{drawerContent?.coupon?.howToRedeem?.linkText}</li>

                )}
                {drawerContent?.coupon?.howToRedeem?.bulletPoints?.map(
                  (point, index) => (
                    <li key={index}>{point}</li>
                  )
                )}
              </ul>
            </div>
          )}
          {drawerContent?.coupon?.termsAndConditions && (
            <div className="bottomDrawer__content__block">
              <div className="bottomDrawer__content__block__header">
                <img src="https://cdn-wl-assets.classplus.co/production/single/learn/b9fe02b3-26e3-468f-a8ea-a8c44c9ae65b.png" alt="icon" />
                <p>Terms & conditions</p>
              </div>
              <ul>
                {drawerContent?.termsAndConditions?.linkText && (
                  <li
                    dangerouslySetInnerHTML={{
                      __html: drawerContent?.termsAndConditions?.linkText,
                    }}
                  ></li>
                )}
                {drawerContent?.termsAndConditions?.bulletPoints?.map(
                  (point, index) => (
                    <li key={index}>{point}</li>
                  )
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BottomDrawer;
